import { Box } from '@mui/material'
import { SelectWithLabel } from 'Components/SelectWithLabel'
import { CheckBoxWithLabel } from 'Components/CheckBox'
import { type lookup } from 'core/types'

export interface SentSearchCriteria {
  schoolYearId: number
  actionInLast30Days: boolean
}

export function SentSearch (props: { current: SentSearchCriteria, onChange: (newSearch: SentSearchCriteria) => void, addButton?: JSX.Element, schoolYearOptions: lookup[] }): JSX.Element {
  const handleChange = (e: any): void => {
    props.onChange({ ...props.current, [e.target.name]: e.target.value })
  }

  return <Box sx={{ boxSizing: 'border-box', alignItems: 'center', p: '4px 0px', gap: '10px', display: 'flex', flexDirection: 'row' }}>
    <SelectWithLabel
      name='schoolYearId'
      label='School Year'
      width='250px'
      value={props.current.schoolYearId}
      options={props.schoolYearOptions}
      onChange={handleChange}
    />
    <CheckBoxWithLabel
      edge='start'
      label='Recently Sent'
      name='recentlySent'
      value={props.current.actionInLast30Days}
      setValue={function (newVal: boolean): void {
        props.onChange({ ...props.current, actionInLast30Days: newVal })
      }}
    />
    {props.addButton}
  </Box>
}
